import React from 'react';

import { HStack, Box, Stack, Center } from '@chakra-ui/react';
import { isEmpty } from 'lodash';

import { formatTooltip, getIcon, PlusCountTag } from 'components/DataDisplay';
import { CustomTooltip } from 'components/DataDisplay/Tooltip/CustomTooltip';

export const renderCompliance = (data: string[]) => {
  return !isEmpty(data) ? (
    <HStack spacing={2}>
      {data.slice(0, 4).map((co, index) => (
        <CustomTooltip label={co} key={index + '-' + co}>
          <Box boxSize={6}>
            <Center>{getIcon(co)}</Center>
          </Box>
        </CustomTooltip>
      ))}
      {data.length > 4 && (
        <CustomTooltip
          label={formatTooltip({
            header: 'Compliance Standards',
            content: (
              <Stack>
                {/* Fixed: add a key to each remaining standard. */}
                {data.slice(4)?.map(o => (
                  <Box key={o}>{o}</Box>
                ))}
              </Stack>
            ),
            width: 56,
          })}
        >
          <PlusCountTag count={data.length - 4} />
        </CustomTooltip>
      )}
    </HStack>
  ) : (
    '-'
  );
};
